import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../../Tabels/Tabels.css";
import plus from "../../../Components/assets/icons/a1.png";
import colunms from "../../../Components/assets/icons/LINES.png";
import search1 from "../../../Components/assets/icons/search.png";
import top from "../../../Components/assets/icons/top.png";
import Table from "react-bootstrap/Table";
import { Link } from "react-router-dom";
import Header from "../../Header/Header";
import { Context } from "../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import toast, { Toaster } from "react-hot-toast";
import AddOffCanvance from "./Add";
import EditOffCanvance from "./Edit";
import ModalDelete from "../../common/ModelDelete";
import ModelBulkUpload from "../../common/ModelBulkUpload";
import { AddButton, EditButton, DeletButton } from "../../common/Button";
import InputGroup from "react-bootstrap/InputGroup";
import Form from "react-bootstrap/Form";
import { Button, Modal } from "react-bootstrap";
import OffcanvasCon from "../../OffcanvasCon/OffcanvasCon";
import DataTable from "datatables.net";
import { formatDateTime, IDS } from "../../../utils/common";
import Pagination_Holder from "../../common/Pagination_Holder/Pagination_Holder";
import Pagination from "react-bootstrap/Pagination";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import ViewWishlistModal from "./ViewWishlistModal";

library.add(fas);

const Tables = () => {
  const {
    getData,
    editStatusData,
    deleteData,
    ErrorNotify,
    Per_Page_Dropdown,
    postData,
    getDownloadDataExcel,
    isAllow,
    IMG_URL,
  } = useContext(Context);

  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setperPage] = useState(5);
  const [search, setSearch] = useState("");
  const [reset, setReset] = useState();
  const [show, setShowAdd] = useState(false);
  const [show1, setShowEdit] = useState(0);
  const [changeStatus, setChangeStatus] = useState();
  const [option, setOption] = useState();
  const [showoff, setShowoff] = useState(false);
  const [totalPages, settotalPages] = useState();
  const [onPageChange, setonPageChange] = useState(1);

  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  // const getDataAll = async () => {
  //   const response = await getData(
  //     `/admin/setting/wishlist?page=${onPageChange}&per_page=${perPage}&term=${search}`,
  //   );
  //   await setData(response);
  //   setCurrentPage(response?.data?.current_page);
  //   setperPage(response?.data?.per_page);
  //   setSearch(response?.data?.search_name);
  //   settotalPages(response?.data?.total_pages);

  //   setOption(await Per_Page_Dropdown(response?.data?.total));

  //   const newData = response?.data?.data;
  //   if (newData) {
  //     const newIds = newData.map((d) => d?.id);
  //     setAllChecked(newIds);
  //   }
  // };

  const getDataAll = async (
    page = onPageChange,
    searchTerm = search,
    startDate = fromDate,
    endDate = toDate,
  ) => {
    try {
      const params = new URLSearchParams({
        page: String(page),
        per_page: String(perPage || 5),
        term: searchTerm.trim(),
      });

      if (startDate) params.append("from", startDate);
      if (endDate) params.append("to", endDate);

      const response = await getData(
        `/admin/setting/wishlist?${params.toString()}`,
      );

      setData(response);

      const result = response?.data;
      const records = result?.data || [];
      const totalRecords = Number(result?.total || 0);

      setCurrentPage(Number(result?.current_page || 1));
      settotalPages(Number(result?.total_pages || 1));

      if (result?.per_page) {
        setperPage(Number(result.per_page));
      }

      // Use the actual total number of matching records.
      const dropdownOptions = await Per_Page_Dropdown(totalRecords);
      setOption(dropdownOptions);

      setAllChecked(records.map((item) => item.id));
    } catch (error) {
      console.error("Error fetching wishlist:", error);
    }
  };

  useEffect(() => {
    getDataAll();
  }, [changeStatus, perPage, reset, onPageChange]);

  const handlePageChange = (pageNumber) => {
    setonPageChange(pageNumber);
  };

  const [selectedWishlist, setSelectedWishlist] = useState(null);
  const [viewLoading, setViewLoading] = useState(false);
  const [previewImage, setPreviewImage] = useState(null);

  const paginationItems = [];
  for (let page = 1; page <= totalPages; page++) {
    paginationItems.push(
      <Pagination.Item
        key={page}
        active={page === onPageChange}
        onClick={() => handlePageChange(page)}
      >
        {page}
      </Pagination.Item>,
    );
  }

  const ChangeStatus = async (id) => {
    const response = await editStatusData(`/admin/wishlist/${id}`);
    setChangeStatus(response);
  };

  // Modal function
  const handleClose = () => setShowAdd(false);
  const handleShow = () => setShowAdd(true);

  const handleClose1 = () => setShowEdit(0);
  const handleShow1 = (id) => {
    setShowEdit(id);
  };

  // Select All Functionality
  const [selectAllChecked, setSelectAllChecked] = useState([]);
  const [allChecked, setAllChecked] = useState([]);

  const handleSelectAll = async () => {
    await setSelectAllChecked(allChecked);
  };

  const handleChange = async (e) => {
    const { value, checked } = e.target;

    if (value === "selectAll") {
      if (checked) {
        handleSelectAll();
      } else {
        await setSelectAllChecked([]);
      }
    } else {
      if (checked) {
        await setSelectAllChecked([...selectAllChecked, Number(value)]);
      } else {
        await setSelectAllChecked(
          selectAllChecked.filter((e) => e !== Number(value)),
        );
      }
    }
  };

  // Delete module
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [recordToDeleteId, setRecordToDeleteId] = useState(null);
  const [recordToDeleteName, setRecordToDeleteName] = useState(null);

  const showDeleteRecord = async (id, name) => {
    setShowDeleteModal(true);
    setRecordToDeleteId(id);
    setRecordToDeleteName(name);
  };

  const handleDeleteRecord = async () => {
    setShowDeleteModal(false);
    if (recordToDeleteId) {
      const response = await deleteData(`/admin/wishlist/${recordToDeleteId}`);
      // notify("error", "Deleted Succefully");

      ErrorNotify(recordToDeleteName);

      setRecordToDeleteId(null);
      setRecordToDeleteName(null);
      setChangeStatus(response);
    }
  };

  const handleDeleteCancel = () => {
    setShowDeleteModal(false);
    setRecordToDeleteId(null);
    setRecordToDeleteName(null);
  };

  //  column hide and show.....
  const [visible, setVisibel] = useState({
    col0: true,
    col1: true,
    col2: true,
    col3: true,
    col4: true,
    col5: true,
    col6: true,
    col7: true,
  });

  //toggle columnns.........
  const toggleColumn = (event, columnName) => {
    event.preventDefault();
    setVisibel((prev) => ({
      ...prev,
      [columnName]: !prev[columnName],
    }));
  };

  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const BulkUpload = async (e) => {
    try {
      const formData = new FormData();
      formData.append("file", e.target.files[0]);
      const response = await postData("/admin/wishlist/bulk", formData, {});
      if (response?.success) {
        setShowModal({ code: response.code, message: response.message });
      } else {
        setShowModal({ code: response.code, message: response.message });
      }
      setTimeout(() => {
        setShowModal(0);
        setShowoff(response?.data);
      }, 1000);
      getDataAll();
    } catch (error) {
      console.error("Error uploading file:", error);
    }
  };

  const Sample = async (e) => {
    try {
      await getDownloadDataExcel("/admin/wishlist/sample", {}, "Category");
    } catch (error) {
      console.error("Error uploading file:", error);
    }
  };

  useEffect(() => {
    const table = new DataTable("#example");
    return () => {
      table.destroy();
    };
  }, []);

  const handleViewWishlist = async (id) => {
    try {
      setViewLoading(true);
      setSelectedWishlist(null);

      const response = await getData(`/admin/setting/wishlist/${id}`);

      if (response?.success && response?.data) {
        setSelectedWishlist(response.data);
      } else {
        toast.error(response?.message || "Failed to fetch wishlist details");
      }
    } catch (error) {
      console.error("Error fetching wishlist details:", error);
      toast.error("Failed to fetch wishlist details");
    } finally {
      setViewLoading(false);
    }
  };

  return (
    <>
      <div className="main-advancedashboard">
        <Header title={"Wishlist Data"} link={"/admin/wishlist"} />
        <section className="AdvanceDashboard">
          <div className="col-lg-12 p-0">
            <div className="row MainRowsec me-0 ms-0">
              <section className="Tabels tab-radio tab-radio mt-3">
                <div className="">
                  {/* container */}
                  <div className="row">
                    <div className="col-xxl-2 col-xl-2 col-lg-4 col-md-6 col-sm-6 col-12">
                      <div className="add me-3">
                        {/* {isAllow.includes(IDS.Brand.Add) ? (
                          <Link
                            // to="/admin/masters/brand/add"
                            type="button"
                            className="btn btn-add pe-3"
                          >
                            <div onClick={() => handleShow()}>
                              <img
                                src={plus}
                                className="plus me-2 ms-0"
                                alt=""
                              />
                              Add Brand
                            </div>
                          </Link>
                        ) : (
                          <></>
                        )} */}
                      </div>
                    </div>
                    {/* <div className="col-xxl-2 col-xl-2 col-lg-4 col-md-6 col-sm-6 col-12 ">
                      <div className="add me-3">
                        <div className="dropdown">
                          <button
                            className="btn btn-columns dropdown-toggle"
                            type="button"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                          >
                            <img
                              src={colunms}
                              className="columns me-2 "
                              alt=""
                            />
                            Column Selection
                            <img src={top} className="top ms-1" alt="" />
                          </button>
                          <ul className="dropdown-menu">
                            <li>
                              <Link
                                className="dropdown-item"
                                onClick={(event) => toggleColumn(event, "col1")}
                                href="#"
                              >
                                Sr. No.
                                {visible?.col1 ? (
                                  <FontAwesomeIcon
                                    className="ms-4"
                                    icon="fa-solid fa-eye"
                                  />
                                ) : (
                                  <FontAwesomeIcon
                                    className="ms-4"
                                    icon="fa-solid fa-eye-slash"
                                  />
                                )}
                              </Link>
                            </li>
                            <li>
                              <Link
                                className="dropdown-item"
                                onClick={(event) => toggleColumn(event, "col2")}
                                href="#"
                              >
                                Brand
                                {visible?.col2 ? (
                                  <FontAwesomeIcon
                                    className="ms-2"
                                    icon="fa-solid fa-eye"
                                  />
                                ) : (
                                  <FontAwesomeIcon
                                    className="ms-2"
                                    icon="fa-solid fa-eye-slash"
                                  />
                                )}
                              </Link>
                            </li>{" "}
                            <li>
                              <Link
                                className="dropdown-item"
                                onClick={(event) => toggleColumn(event, "col5")}
                                href="#"
                              >
                                Image
                                {visible?.col5 ? (
                                  <FontAwesomeIcon
                                    className="ms-2"
                                    icon="fa-solid fa-eye"
                                  />
                                ) : (
                                  <FontAwesomeIcon
                                    className="ms-2"
                                    icon="fa-solid fa-eye-slash"
                                  />
                                )}
                              </Link>
                            </li>
                            <li>
                              <Link
                                className="dropdown-item"
                                onClick={(event) => toggleColumn(event, "col3")}
                                href="#"
                              >
                                Status
                                {visible?.col3 ? (
                                  <FontAwesomeIcon
                                    className="ms-4"
                                    icon="fa-solid fa-eye"
                                  />
                                ) : (
                                  <FontAwesomeIcon
                                    className="ms-4"
                                    icon="fa-solid fa-eye-slash"
                                  />
                                )}
                              </Link>
                            </li>
                            <li>
                              <Link
                                className="dropdown-item"
                                onClick={(event) => toggleColumn(event, "col4")}
                                href="#"
                              >
                                Action
                                {visible?.col4 ? (
                                  <FontAwesomeIcon
                                    className="ms-4"
                                    icon="fa-solid fa-eye"
                                  />
                                ) : (
                                  <FontAwesomeIcon
                                    className="ms-4"
                                    icon="fa-solid fa-eye-slash"
                                  />
                                )}
                              </Link>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div> */}

                    {/* {isAllow?.includes(210) ? (
                          <div className="add me-3">
                            <button
                              className="btn btn-add pe-3"
                              onClick={() =>
                                document.getElementById("CategoryFile").click()
                              }
                            >
                              Bulk Upload
                            </button>

                            <input
                              type="file"
                              id="CategoryFile"
                              onChange={(e) => {
                                BulkUpload(e);
                              }}
                              accept=".csv, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                              style={{ display: "none" }}
                            />
                          </div>
                        ) : (
                          <></>
                        )}
                        {isAllow?.includes(210) ? (
                          <div className="add me-3">
                            <Link type="button" className="btn btn-add pe-3">
                              <div onClick={Sample}>Sample</div>
                            </Link>
                          </div>
                        ) : (
                          <></>
                        )} */}

                    <div className="border-line mt-3"></div>
                    <div className="row mt-4">
                      <div className=" col-12">
                        <div className="d-flex align-items-center mb-3">
                          <div className="show me-2">
                            <p className="show m-0">Show</p>
                          </div>
                          <div className="number me-2">
                            <select
                              className="form-select form-select-sm top-select-no"
                              aria-label="Show entries"
                              value={perPage}
                              onChange={(e) => {
                                setperPage(Number(e.target.value));
                                setonPageChange(1);
                              }}
                            >
                              {option?.map((item, index) => {
                                const value =
                                  typeof item === "object" ? item.value : item;

                                const label =
                                  typeof item === "object" ? item.label : item;

                                return (
                                  <option
                                    key={`${value}-${index}`}
                                    value={value}
                                  >
                                    {label}
                                  </option>
                                );
                              })}
                            </select>
                          </div>
                          <div className="entries">
                            <p className="show m-0">entries</p>
                          </div>
                          <div className="sowing ms-3 me-2">
                            <p className="show m-0">
                              {`Showing ${
                                data?.data?.data?.length
                                  ? (Number(currentPage) - 1) *
                                      Number(perPage) +
                                    1
                                  : 0
                              } to ${
                                (Number(currentPage) - 1) * Number(perPage) +
                                (data?.data?.data?.length || 0)
                              } of ${data?.data?.total || 0} entries`}
                            </p>
                          </div>
                        </div>
                      </div>

                      <div className="col-12">
                        <div className="row align-items-end g-3">
                          <div className="col-12 col-md-6 col-lg-4 col-xl-3">
                            <Form.Group>
                              <Form.Label>Search</Form.Label>
                              <Form.Control
                                type="text"
                                value={search}
                                placeholder="Name, email, contact, product..."
                                onChange={(e) => setSearch(e.target.value)}
                                onKeyDown={(e) => {
                                  if (e.key === "Enter") {
                                    e.preventDefault();
                                    setonPageChange(1);
                                    getDataAll(1, search, fromDate, toDate);
                                  }
                                }}
                              />
                            </Form.Group>
                          </div>

                          <div className="col-12 col-sm-6 col-lg-3 col-xl-2">
                            <Form.Group>
                              <Form.Label>Start Date</Form.Label>
                              <Form.Control
                                type="date"
                                value={fromDate}
                                max={toDate || undefined}
                                onChange={(e) => setFromDate(e.target.value)}
                              />
                            </Form.Group>
                          </div>

                          <div className="col-12 col-sm-6 col-lg-3 col-xl-2">
                            <Form.Group>
                              <Form.Label>End Date</Form.Label>
                              <Form.Control
                                type="date"
                                value={toDate}
                                min={fromDate || undefined}
                                onChange={(e) => setToDate(e.target.value)}
                              />
                            </Form.Group>
                          </div>

                          <div className="col-6 col-lg-2 col-xl-2">
                            <Button
                              type="button"
                              className="btn btn-search w-100"
                              onClick={() => {
                                setonPageChange(1);
                                getDataAll(1, search, fromDate, toDate);
                              }}
                            >
                              <img src={search1} className="search" alt="" />
                              <span className="ms-2">Search</span>
                            </Button>
                          </div>

                          <div className="col-6 col-lg-2 col-xl-2">
                            <Button
                              type="button"
                              className="btn btn-reset w-100"
                              onClick={() => {
                                setSearch("");
                                setFromDate("");
                                setToDate("");
                                setonPageChange(1);
                                setReset((prev) => !prev);
                                getDataAll(1, "", "", "");
                              }}
                            >
                              Reset
                            </Button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="border-line mt-3"></div>
                  <div className="row mt-3">
                    <div className="data table-responsive">
                      <Table striped bordered hover responsive center>
                        <thead>
                          <tr>
                            {visible.col1 && <th className="sr">Sr. No.</th>}
                            {visible.col2 && <th>User Details</th>}
                            {visible.col3 && <th>Contact No.</th>}
                            {visible.col4 && <th>Product</th>}
                            {visible.col5 && <th>Image</th>}
                            {visible.col0 && <th>Added On</th>}
                            {visible.col6 && <th className="active">Action</th>}
                          </tr>
                        </thead>

                        <tbody>
                          {data?.data?.data?.length > 0 ? (
                            data.data.data.map((d, index) => {
                              const user = d?.User;
                              const product = d?.Product;

                              const paginatedIndex =
                                (Number(onPageChange) - 1) * Number(perPage) +
                                index +
                                1;

                              const imageUrl = product?.image
                                ? product.image.startsWith("http")
                                  ? product.image
                                  : IMG_URL + product.image
                                : null;

                              return (
                                <tr key={d.id}>
                                  {visible.col1 && <td>{paginatedIndex}.</td>}

                                  {visible.col2 && (
                                    <td>
                                      <strong>
                                        {[user?.name, user?.last_name]
                                          .filter(Boolean)
                                          .join(" ") || "N/A"}
                                      </strong>
                                      <div className="text-muted">
                                        {user?.email || "N/A"}
                                      </div>
                                    </td>
                                  )}

                                  {visible.col3 && (
                                    <td>{user?.contact_no || "N/A"}</td>
                                  )}

                                  {visible.col4 && (
                                    <td>
                                      <strong>{product?.name || "N/A"}</strong>
                                      <div className="text-muted">
                                        ID:{" "}
                                        {product?.id ?? d?.product_id ?? "N/A"}
                                      </div>
                                      <div className="text-muted">
                                        Item Code: {product?.item_code || "N/A"}
                                      </div>
                                    </td>
                                  )}

                                  {visible.col5 && (
                                    <td>
                                      {imageUrl ? (
                                        <img
                                          src={imageUrl}
                                          alt={product?.name || "Product"}
                                          className="product-image"
                                          onClick={() =>
                                            setPreviewImage(imageUrl)
                                          }
                                          style={{
                                            cursor: "pointer",
                                            width: "65px",
                                            height: "65px",
                                            objectFit: "contain",
                                          }}
                                          title="Click to preview image"
                                        />
                                      ) : (
                                        "No Image"
                                      )}
                                    </td>
                                  )}

                                  {visible.col0 && (
                                    <td>{formatDateTime(d?.createdAt)}</td>
                                  )}

                                  {/* {visible.col0 && (
                                    <td>
                                      <div>
                                        <strong>Price:</strong>{" "}
                                        {(product?.Product_Variants?.[0]
                                          ?.price ?? product?.price) != null
                                          ? `₹${product?.Product_Variants?.[0]?.price ?? product?.price}`
                                          : "N/A"}
                                      </div>

                                      <div>
                                        <strong>MRP:</strong>{" "}
                                        {(product?.Product_Variants?.[0]?.mrp ??
                                          product?.mrp) != null
                                          ? `₹${product?.Product_Variants?.[0]?.mrp ?? product?.mrp}`
                                          : "N/A"}
                                      </div>
                                    </td>
                                  )} */}

                                  {visible.col6 && (
                                    <td>
                                      <button
                                        type="button"
                                        className="btn btn-sm btn-outline-primary"
                                        title="View wishlist details"
                                        disabled={viewLoading}
                                        onClick={() => handleViewWishlist(d.id)}
                                      >
                                        <FontAwesomeIcon icon={faEye} />
                                      </button>
                                    </td>
                                  )}
                                </tr>
                              );
                            })
                          ) : (
                            <></>
                          )}
                        </tbody>
                      </Table>
                      {data && data?.data?.data?.length > 0 ? (
                        <Pagination_Holder
                          onPageChange={currentPage}
                          totalPages={totalPages}
                          handlePageChange={handlePageChange}
                        />
                      ) : (
                        <p className="no-datashow">Sorry, No Data Found</p>
                      )}
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </section>
      </div>

      {show ? (
        <AddOffCanvance
          handleClose={handleClose}
          setShow={setShowAdd}
          show={show}
        />
      ) : (
        ""
      )}

      {show1 ? (
        <EditOffCanvance
          handleClose={handleClose1}
          setShow={setShowEdit}
          show={show1}
        />
      ) : (
        ""
      )}

      <ModalDelete
        show={showDeleteModal}
        handleDeleteRecord={handleDeleteRecord}
        handleDeleteCancel={handleDeleteCancel}
      />

      <ModelBulkUpload
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
      <Toaster position="top-right" />

      <OffcanvasCon show={showoff} handleClose={() => setShowoff(false)} />

      {/* Wishlist details modal */}
      <ViewWishlistModal
        show={selectedWishlist}
        handleClose={() => setSelectedWishlist(null)}
        IMG_URL={IMG_URL}
        onImageClick={setPreviewImage}
      />

      {/* Full-size product image preview */}
      <Modal
        show={!!previewImage}
        onHide={() => setPreviewImage(null)}
        centered
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Product Image Preview</Modal.Title>
        </Modal.Header>

        <Modal.Body className="text-center">
          {previewImage && (
            <img
              src={previewImage}
              alt="Product preview"
              style={{
                maxWidth: "100%",
                maxHeight: "75vh",
                objectFit: "contain",
              }}
            />
          )}
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Tables;
